// extracted by mini-css-extract-plugin
export var quillEditor = "_pr-1";
export var variable = "_pr-0";